import React from "react";
import Text from "../typography/Text";

export default ({
  name,
  value,
  label,
  notice,
  checked = false,
  setValue = () => {},
  ...modifiers
}) => {
  let className = "radioButton";
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );
  return (
    <label className={className}>
      <input
        className="radioButton_input"
        type="radio"
        checked={checked}
        name={name}
        value={value}
        onChange={event => setValue(event.target.value)}
      />
      <span className="radioButton_checkmark"></span>
      <span className="radioButton_label">{label}</span>
      {notice && (
        <div className="radioButton_notice">
          <Text small>{notice}</Text>
        </div>
      )}
    </label>
  );
};
